import React from 'react';
import ProductExcelBulkEditSummaryBox from '../ProductExcelBulkEditSummaryBox';
import ProductExcelBulkEditList from '../ProductExcelBulkEditList';
import FixedBottomNavBar from '../../../../../../components/FixedBottomNavBar';
import Button from '../../../../../../components/Button';
import './ProductExcelBulkEditWrap.scss';

const ProductExcelBulkEditWrap = (props) => {
  const { excelBulkEditProduct, validateTest, bulkEditProduct } = props;
  const { file, bulkEditProductValidResultList, bulkEditProductValidResultCount } = excelBulkEditProduct;

  return (
    <div className="product-excel-bulk-edit-wrap">
      {/* summary / 파일 업로드 */}
      <ProductExcelBulkEditSummaryBox
        file={file}
        bulkEditProductValidResultCount={bulkEditProductValidResultCount}
        onChange={validateTest}
      />

      {/* 유효성 결과 리스트 */}
      <ProductExcelBulkEditList bulkEditProductValidResultList={bulkEditProductValidResultList} />

      {/* 엑셀 업로드 / 일괄 편집 */}
      <FixedBottomNavBar className="product-excel-bulk-edit-navbar">
        <div className="button-group">
          <div className="right">
            {bulkEditProductValidResultList.length ? (
              <Button color="primary" text="수정하기" onClick={() => bulkEditProduct()} />
            ) : null}
          </div>
        </div>
      </FixedBottomNavBar>
    </div>
  );
};

export default ProductExcelBulkEditWrap;
